import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from '@/constants/env';
import { getUIRole } from '@/pages/UserPreferences/utils';

export class MixpanelManager {
  public static init() {
    if (MIXPANEL_TOKEN) {
      mixpanel.init(MIXPANEL_TOKEN, {
        api_host: 'https://mixpanel-proxy-27272169904.us-central1.run.app/',
        persistence: 'localStorage',
        track_pageview: false,
      });
    }
  }
  public static registerMixpanel(user: {
    userId: string;
    displayName: string;
    email: string;
    org: string;
    permission: string;
    phoneNumber?: string;
    title?: string;
    role?: string;
  }) {
    if (MIXPANEL_TOKEN) {
      const mergedPermission = getUIRole(user.role || '', user.permission || '');
      mixpanel.identify(user.userId);
      mixpanel.people.set({
        $name: user.displayName,
        $email: user.email,
        $company_name: user.org,
        $permission: mergedPermission,
        $title: user.title || '',
        $phoneNumber: user.phoneNumber || '',
      });
    }
  }

  public static pushTrackEvent(eventName: string, payload?: any) {
    if (MIXPANEL_TOKEN) {
      mixpanel.track(eventName, payload);
    }
  }

  public static pushCustomData(key: string, value: any) {
    if (MIXPANEL_TOKEN) {
      mixpanel.people.set({
        [key]: value,
      });
    }
  }

  public static setUserStats(stats: {
    products_active: number;
    products_deleted: number;
    collections_active: number;
    collections_deleted: number;
  }) {
    if (MIXPANEL_TOKEN) {
      // Attach as super properties for future events
      mixpanel.register({
        products_active: stats.products_active,
        products_deleted: stats.products_deleted,
        collections_active: stats.collections_active,
        collections_deleted: stats.collections_deleted,
      });

      // Also persist as people properties
      mixpanel.people.set({
        products_active: stats.products_active,
        products_deleted: stats.products_deleted,
        collections_active: stats.collections_active,
        collections_deleted: stats.collections_deleted,
      });
    }
  }
}
